// Renders multi-line text to a PNG data URL used as a document stamp.
// options is optional so existing callers keep the previous look (17px Arial, black).
const getMultipleTxtToImg = (value, cb, options = {}) => {
    const { fontSize = 17, color = '#000000', fontFamily = 'Arial' } = options;

    const size = parseInt(fontSize, 10) || 17;
    const lineHeight = Math.round(size * 1.3);
    const font = `${size}px ${fontFamily}`;

    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d');
    const lines = String(value == null ? '' : value).split('\n');

    // Measure with the final font before sizing the canvas
    ctx.font = font;
    const longest = lines.reduce((r, e) => (r.length < e.length ? e : r), '');
    canvas.width = ctx.measureText(longest).width + 90;
    canvas.height = lines.length * lineHeight + 20;

    // Resizing the canvas resets the 2D context, so font/colour must be applied
    // again here - not just before the resize.
    ctx.font = font;
    ctx.fillStyle = color;
    ctx.textBaseline = 'top';

    for (let i = 0; i < lines.length; i++) {
        ctx.fillText(lines[i], 20, lineHeight * i + 10);
    }

    const img = document.createElement('img');
    img.src = ctx.canvas.toDataURL();
    cb(img.src);
};
export default getMultipleTxtToImg;
